import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpUpdateExternalCost, HttpUpdateExternalCostOptions} from '../http/budget.http'
import {ExternalCost} from '../types'

export const useUpdateExternalCost = (
    options?: UseMutationOptions<ExternalCost, unknown, HttpUpdateExternalCostOptions>
) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (variables: HttpUpdateExternalCostOptions) => httpUpdateExternalCost(variables),
        ...options,
        onSuccess: async (data, variables, context) => {
            await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.EXTERNAL_COSTS]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
